// extracted by mini-css-extract-plugin
export default {"option":"dropdown_option__n-Olx"};